// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* UserManagement Page  Premium Dashboard */

.user-management-page h1 { display: none; }

.user-management-page .toolbar {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}

.user-management-page .toolbar .btn-primary {
  border-radius: 10px;
  padding: 10px 20px;
  font-size: 0.85rem;
  font-weight: 600;
}

.user-form-card {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 28px;
  margin-bottom: 24px;
}

.user-form-card h3 {
  font-size: 1rem;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 20px;
}

.user-form-card .form-row {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin-bottom: 16px;
}

.user-form-card label {
  font-size: 0.82rem;
  font-weight: 600;
  color: #475569;
  margin-bottom: 6px;
  display: block;
}

.user-form-card input,
.user-form-card select {
  width: 100%;
  padding: 10px 14px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 0.88rem;
  transition: border-color 0.2s, box-shadow 0.2s;
  background: #fff;
}

.user-form-card input:focus,
.user-form-card select:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59,130,246,0.1);
}

.user-form-card .form-actions {
  display: flex;
  gap: 10px;
  margin-top: 20px;
}

.user-form-card .btn {
  border-radius: 10px;
  padding: 10px 20px;
  font-size: 0.85rem;
  font-weight: 600;
}

.user-table-container {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
}

.user-table-container table {
  width: 100%;
  border-collapse: collapse;
}

.user-table-container thead {
  background: #f8fafc;
  border-bottom: 2px solid #e2e8f0;
}

.user-table-container th {
  padding: 14px 20px;
  font-size: 0.78rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #64748b;
  text-align: left;
}

.user-table-container td {
  padding: 16px 20px;
  font-size: 0.88rem;
  color: #334155;
  border-bottom: 1px solid #f1f5f9;
}

.user-table-container tr:hover td {
  background: #f8fafc;
}

.user-table-container .btn {
  padding: 6px 14px;
  font-size: 0.78rem;
  border-radius: 6px;
  margin-right: 6px;
}

.user-table-container .btn-danger {
  background: #fee2e2;
  color: #dc2626;
  border: none;
}

.user-table-container .btn-danger:hover { background: #fecaca; }

@media (max-width: 768px) {
  .user-form-card .form-row { grid-template-columns: 1fr; }
}
`, "",{"version":3,"sources":["webpack://./src/styles/UserManagement.css"],"names":[],"mappings":"AAAA,2CAA2C;;AAE3C,2BAA2B,aAAa,EAAE;;AAE1C;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;AACd;;AAEA,0CAA0C,mBAAmB,EAAE;;AAE/D;EACE,4BAA4B,0BAA0B,EAAE;AAC1D","sourcesContent":["/* UserManagement Page  Premium Dashboard */\n\n.user-management-page h1 { display: none; }\n\n.user-management-page .toolbar {\n  display: flex;\n  justify-content: flex-end;\n  margin-bottom: 20px;\n}\n\n.user-management-page .toolbar .btn-primary {\n  border-radius: 10px;\n  padding: 10px 20px;\n  font-size: 0.85rem;\n  font-weight: 600;\n}\n\n.user-form-card {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 28px;\n  margin-bottom: 24px;\n}\n\n.user-form-card h3 {\n  font-size: 1rem;\n  font-weight: 700;\n  color: #1e293b;\n  margin-bottom: 20px;\n}\n\n.user-form-card .form-row {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 16px;\n  margin-bottom: 16px;\n}\n\n.user-form-card label {\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: #475569;\n  margin-bottom: 6px;\n  display: block;\n}\n\n.user-form-card input,\n.user-form-card select {\n  width: 100%;\n  padding: 10px 14px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 0.88rem;\n  transition: border-color 0.2s, box-shadow 0.2s;\n  background: #fff;\n}\n\n.user-form-card input:focus,\n.user-form-card select:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59,130,246,0.1);\n}\n\n.user-form-card .form-actions {\n  display: flex;\n  gap: 10px;\n  margin-top: 20px;\n}\n\n.user-form-card .btn {\n  border-radius: 10px;\n  padding: 10px 20px;\n  font-size: 0.85rem;\n  font-weight: 600;\n}\n\n.user-table-container {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.user-table-container table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.user-table-container thead {\n  background: #f8fafc;\n  border-bottom: 2px solid #e2e8f0;\n}\n\n.user-table-container th {\n  padding: 14px 20px;\n  font-size: 0.78rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: #64748b;\n  text-align: left;\n}\n\n.user-table-container td {\n  padding: 16px 20px;\n  font-size: 0.88rem;\n  color: #334155;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.user-table-container tr:hover td {\n  background: #f8fafc;\n}\n\n.user-table-container .btn {\n  padding: 6px 14px;\n  font-size: 0.78rem;\n  border-radius: 6px;\n  margin-right: 6px;\n}\n\n.user-table-container .btn-danger {\n  background: #fee2e2;\n  color: #dc2626;\n  border: none;\n}\n\n.user-table-container .btn-danger:hover { background: #fecaca; }\n\n@media (max-width: 768px) {\n  .user-form-card .form-row { grid-template-columns: 1fr; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
